import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/articles";

const latestArticles = allArticles.filter((a) => a.slug !== "basetao-spreadsheet-guide");

export default function LatestArticlesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-medium rounded-full mb-4">
            Latest Articles
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            In-Depth BaseTao SEO Guides &amp; Resources
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Explore our growing collection of comprehensive, independently researched BaseTao guides covering reviews, shipping, discounts, safety, and expert strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div
                className="w-full aspect-[16/10] bg-cover bg-center"
                style={{
                  backgroundImage: `url('${article.imageUrl}')`,
                }}
              ></div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-0.5 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 mt-auto">
                  Read Article
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse All Guides
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}